import { faCheck, faPlus, faStepBackward, faUndo } from '@fortawesome/free-solid-svg-icons';
import {
    MovementDataStore,
    MovementLifecycleStates,
    movementSelectors,
    MovementTypes,
} from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Component, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';

import {
    ADD_ITEM_TOPIC,
    CANCEL_MOVEMENT_TOPIC,
    CLOSE_MOVEMENT_TOPIC,
    CREATE_MOVEMENT_TOPIC,
    RETURN_MOVEMENT_TOPIC,
} from '../../../../busTopics';
import { Routes } from '../../../../router';

@Component({
    props: ['entityDataStore'],
    template: require('./action-menu-movement.html'),
})
export class ActionMenuMovement extends ReactiveVue {
    public plusIcon = faPlus;
    public checkIcon = faCheck;
    public undoIcon = faUndo;
    public stepBackwardIcon = faStepBackward;
    public entityDataStore: MovementDataStore;
    public entity: any = null;
    public $route: Route;

    public canAddItem: boolean = false;
    public canBeClose: boolean = false;
    public canBeCancel: boolean = false;
    public canBeReturn: boolean = false;
    public canCreate: boolean = false;

    public addItem() {
        this.emitOnBus(ADD_ITEM_TOPIC);
        this.$emit('toggle');
    }

    public cancelMovement() {
        this.emitOnBus(CANCEL_MOVEMENT_TOPIC);
        this.$emit('toggle');
    }

    public closeMovement() {
        this.emitOnBus(CLOSE_MOVEMENT_TOPIC);
        this.$emit('toggle');
    }

    public returnMovement() {
        this.emitOnBus(RETURN_MOVEMENT_TOPIC);
    }

    public createMovement() {
        this.emitOnBus(CREATE_MOVEMENT_TOPIC);
        this.$emit('toggle');
    }

    public created() {
        if (this.$route.name === Routes.MOVEMENT) {
            this.subscribeToEntity();
        } else if (this.$route.name === Routes.MOVEMENTS) {
            this.canCreate = true;
        }
    }

    public subscribeToEntity() {
        this.subscribeTo(
            this.entityDataStore.fetchOne(this.$route.params.id),
            entity => {
                this.entity = entity;
            },
            'entity',
        );
    }

    @Watch('$route', { deep: true })
    @Watch('entityDataStore')
    public onDataStoreChange() {
        this.unsubscribeFrom('entity');
        if (this.$route.name === Routes.MOVEMENT) {
            this.subscribeToEntity();
        } else if (this.$route.name === Routes.MOVEMENTS) {
            this.unsubscribeFrom('entity');
            this.entity = null;
        }
    }

    @Watch('entity', { deep: true, immediate: true })
    public onEntityChange(entity) {
        const availableLifecycleStates = movementSelectors.availableLifecycleStates(entity);
        const state = movementSelectors.state(entity);
        const movementType = movementSelectors.movementType(entity);

        this.canBeClose =
            state === MovementLifecycleStates.IN_PROGRESS ||
            state === MovementLifecycleStates.PROGRAMMED;
        this.canBeCancel = availableLifecycleStates.includes(MovementLifecycleStates.CANCELED);
        this.canBeReturn =
            movementType !== MovementTypes.RETURN && state === MovementLifecycleStates.FINALIZED;
        this.canAddItem = state && state !== MovementLifecycleStates.FINALIZED;
        this.canCreate = this.$route.name === Routes.MOVEMENTS;
    }
}
